import { render, staticRenderFns } from "./memberbalance-add-or-update.vue?vue&type=template&id=66d4a9a2&"
import script from "./memberbalance-add-or-update.vue?vue&type=script&lang=js&"
export * from "./memberbalance-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports